import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPopupMessage } from "../../redux/popupMessage"

const Popup = () => {
    const dispatch = useDispatch();
    const { message } = useSelector((state) => state.popupMessage);

    return (
        <>
            {message && (
                <>
                    <div className="components-popupMessage active">
                        <div className="box">
                            <div className="close" onClick={() => dispatch(setPopupMessage(null))}>
                                <img src="/images/close3.svg" alt="" />
                            </div>
                            <div className="content">{message}</div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Popup;
